import React from "react";

export default function InstrPanelHeader({ user }) {
   return (
      <div className="intro__left">
         <h2>
            Bine ai venit,{" "}
            <span className="highlight-name">{user ? user.firstName : "..."}</span>
         </h2>
         <p>
            Acesta este panoul tau de instructor. Aici vezi lectiile de azi,
            urmatoarele programari si cele finalizate, iar din calendar poti
            urmari rapid toata saptamana de lucru.
         </p>
      </div>
   );
}
